/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_PlaceInputs */

const en_us2_search_field_place = /** @type {(inputs: Search_Field_PlaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where you train`)
};

const pt_br2_search_field_place = /** @type {(inputs: Search_Field_PlaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde você treina`)
};

const es_419_search_field_place = /** @type {(inputs: Search_Field_PlaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dónde entrenas`)
};

const pt_pt2_search_field_place = /** @type {(inputs: Search_Field_PlaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde treinas`)
};

const fr_fr2_search_field_place = /** @type {(inputs: Search_Field_PlaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Où tu t'entraînes`)
};

const de_de2_search_field_place = /** @type {(inputs: Search_Field_PlaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo du trainierst`)
};

const it_it2_search_field_place = /** @type {(inputs: Search_Field_PlaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dove ti alleni`)
};

/**
* | output |
* | --- |
* | "Where you train" |
*
* @param {Search_Field_PlaceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_place = /** @type {((inputs?: Search_Field_PlaceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_PlaceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_place(inputs)
	if (locale === "es-419") return es_419_search_field_place(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_place(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_place(inputs)
	if (locale === "de-DE") return de_de2_search_field_place(inputs)
	if (locale === "it-IT") return it_it2_search_field_place(inputs)
	return en_us2_search_field_place(inputs)
});
export { search_field_place as "search.field_place" }